import { Grid, TableCell, TableRow } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import PageTitle from "../../../components/pageTitle/PageTitle";
import TableDesign, {
  TableHeading,
} from "../../../components/common/table/TableDesign";
import {
  getAllVehicles,
  getAllVehiclesWithPagination,
  setAddVehicleResponse,
  setUpdateVehicleResponse,
} from "../../../store/reducers/vehicleSlice";
import { useSelector } from "react-redux";
import ManageVehicles from "./ManageVehicles";

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  search: string;
}

interface VehicleListProps {
  setSelectedId?: any;
  selectedId?: any;
}

const ROW_HEIGHT = 50; // px, adjust to your row/card height

const VehicleList: React.FC<VehicleListProps> = ({
  setSelectedId,
  selectedId,
}) => {

   const lastLimitRef = useRef<number>(-1);
  
  const dispatch = useDispatch();
  const { vehicles, vehiclePaginationData, isAddVehicleResponse, isUpdateVehicleResponse } =
    useSelector((state: any) => state.vehicle);
    const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
    search: "",
  });

  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  useEffect(() => {
    dispatch(getAllVehiclesWithPagination(filterOption));
  }, [dispatch, filterOption]);
  useEffect(() => {
    const hasSelectedVehicle = vehicles.some((vehicle: any) => vehicle.id === selectedId);

    if (vehicles.length > 0 && (!selectedId || !hasSelectedVehicle)) {
      setSelectedId(vehicles[0].id); // auto-select first remaining vehicle
      return;
    }

    if (vehicles.length === 0 && selectedId) {
      setSelectedId(null);
    }
  }, [vehicles, selectedId, setSelectedId]);


  // Dynamically set limit based on page height, debounce resize, only update if changed
      useEffect(() => {
        let resizeTimeout: any;
        function updateLimit() {
          const pageHeight = window.innerHeight;
          const newLimit = Math.max(5, Math.floor(pageHeight / ROW_HEIGHT));
          if (lastLimitRef.current !== newLimit) {
            lastLimitRef.current = newLimit;
            setFilterOption((prev) => ({
              ...prev,
              limit: newLimit,
            }));
          }
        }
        function onResize() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(updateLimit, 200);
        }
        updateLimit();
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
      }, []);
      

  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Name", align: "left" },
    { label: "Vehicle Type", align: "left" },
  ];

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (isAddVehicleResponse || isUpdateVehicleResponse) {
      setOpen(false);
      dispatch(getAllVehiclesWithPagination(filterOption));
      dispatch(setAddVehicleResponse(false));
      dispatch(setUpdateVehicleResponse(false));
    }
  }, [dispatch, isAddVehicleResponse, isUpdateVehicleResponse, filterOption]);
  return (
    <>
      {open && (
        <ManageVehicles
          open={open}
          onHide={() => setOpen(false)}
          title="New Vehicle"
          selectedVehicle={{}}
          setSelectedVehicle={() => {}}
          action="add"
        />
      )}
      <Grid container sx={{ height: "100%" }}>
        <Grid item md={12} xs={12} id="userList" sx={{ height: "100%",border:'1px solid #CFCFCF',borderRadius:'5px',padding:'8px',overflow:'hidden' }}>
          <PageTitle title="Vehicle" button="Add" onClick={handleOpen} />
          <TableDesign
            tableHeadings={tableHeadings}
            pagination={vehiclePaginationData}
            stickyHeader={true}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            tableHeadColor="#E5F4F1"
            extraCSS={{
              // height: "calc(100% - 100px)",
              maxHeight:'100%',
            }}
          >
            {vehicles.length > 0 ? (
              vehicles?.map((val: any, idx: number) => (
                <TableRow
                  key={val?.id}
                  onClick={() => setSelectedId(val?.id)}
                  sx={{
                    cursor: "pointer",
                    marginTop: "10px",
                    padding: "4px !important",
                    borderRadius: "20px !important",
                    backgroundColor:
                      selectedId === val?.id ? "#f0f0f0" : "transparent", // ✅ active row bg
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                      outline: "2px solid #f0f0f0",
                      borderRadius: "0px !important",
                      outlineOffset: "-2px !important",
                    },
                  }}
                >
                  <TableCell align="left">{idx + 1}</TableCell>
                  <TableCell>{val?.name}</TableCell>
                  <TableCell>{val?.vehicle_type}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No vehicles found.
                </TableCell>
              </TableRow>
            )}
          </TableDesign>
        </Grid>
      </Grid>
    </>
  );
};
export default VehicleList;
